<template>
    <v-alert
        v-if="showAlert"
        :type="alertType"
        class="mx-auto text-center"
        style="position: fixed; top: 20px; left: 0; right: 0; z-index: 9999; max-width: 600px;"
        elevation="2"
        prominent
    >
        {{ alertMessage }}
    </v-alert>
    <v-container>
        <v-alert v-if="errorMsg" type="error" class="mb-3" dense>
            {{ errorMsg }}
        </v-alert>

        <v-card class="pa-4" elevation="2">
            <v-row>
                <v-col class="headline mb-4">
                    <h2>{{ user.id ? 'Editar usuario' : 'Nuevo usuario' }}</h2>
                </v-col>
                <v-col cols="12" sm="6" style="text-align: right">
                    <v-btn style="margin-left: 10px"  @click="$router.back()">Volver</v-btn>
                </v-col>
            </v-row>

            <v-form @submit.prevent="submitForm" ref="formRef">
                <v-text-field
                    v-model="user.name"
                    label="Nombre"
                    :rules="[rules.required]"
                    required
                />

                <v-text-field
                    v-model="user.email"
                    label="Email"
                    type="email"
                    name="fake_email"
                    autocomplete="new-email"
                    :rules="[rules.required, rules.email]"
                    required
                    :disabled="!!user.id"
                />

                <v-text-field
                    v-model="user.password"
                    label="Contraseña"
                    type="password"
                    name="fake_password"
                    autocomplete="new-password"
                    :rules="[!user.id ? rules.required : () => true]"
                    :required="!user.id"
                />


                <v-select
                    v-model="user.role"
                    :items="roles"
                    item-title="text"
                    item-value="value"
                    label="Tipo de usuario"
                    :rules="[rules.required]"
                    required
                />

                <!-- Només mostra client_id si role === 'client' -->
                <v-select
                    v-if="user.role === 'client'"
                    v-model="user.client_id"
                    :items="clients"
                    item-title="name"
                    item-value="odoo_id"
                    label="Client"
                />

                <v-btn type="submit" color="primary" class="mt-4">
                    {{ user.id ? 'Actualizar' : 'Crear' }}
                </v-btn>
            </v-form>
        </v-card>
    </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

import { useAlert } from '@/composables/useAlert'

const {
    alertMessage,
    alertType,
    showAlert,
    showAlertMessage
} = useAlert()

const user = ref({
    id: null,
    name: '',
    email: '',
    password: '',
    role: '',
    client_id: null
})

const roles = [
    { text: 'Administrador', value: 'admin' },
    { text: 'Cliente', value: 'client' },
    { text: 'Calidad', value: 'quality' },
    { text: 'Proveedor', value: 'provider' },
    { text: 'Almacen BCN', value: 'warehouseBCN' },
    { text: 'Almacen MAD', value: 'warehouseMAD' },
    { text: 'Producción', value: 'production' },
    { text: 'Planificación', value: 'planning' },
    { text: 'Comercial', value: 'comercial' },
    { text: 'BackOffice', value: 'backoffice' },
    { text: 'Gerencia', value: 'gerencia' },
    { text: 'Compres', value: 'compres' }
]

const rules = {
    required: v => !!v || 'Este campo es obligatorio',
    email: v => /.+@.+\..+/.test(v) || 'Email no válido',
}

const formRef = ref(null)
const errorMsg = ref('')

const fetchUser = async () => {
    if (!route.params.id) return
    try {
        const res = await axios.get(`/api/admin/users/${route.params.id}`, {
          withCredentials: true,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        const { id, name, email, role, client_id } = res.data
        user.value = {
            id,
            name,
            email,
            password: '',
            role,
            client_id
        }
    } catch (e) {
        showAlertMessage('No se pudo cargar el usuario.', 'error')
    }
}

const submitForm = async () => {
    const { valid } = await formRef.value.validate()
    if (!valid) return

    errorMsg.value = ''

    // Elimina el password si està buit
    if (!user.value.password) {
      delete user.value.password
    }

    console.log('Datos a enviar:', user.value)

    try {
        if (user.value.id) {
            await axios.put(`/api/admin/users/${user.value.id}`, user.value, {
              withCredentials: true,
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              }
            })
        } else {
            await axios.post('/api/admin/users', user.value, {
              withCredentials: true,
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              }
            })
        }
        router.push({ name: 'users.index' })
    } catch (e) {
        console.error('Error guardando usuario:', e)
        showAlertMessage('No se ha podido guardar el usuario.', 'error')
    }
}

const resetUser = () => {
    user.value = {
        id: null,
        name: '',
        email: '',
        password: '',
        role: '',
        client_id: ''
    }
}

const clients = ref([])

const getClients = async () => {
    try {
        const { data } = await axios.get('/api/admin/clients', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        clients.value = data
    } catch (e) {
        showAlertMessage('Error carregando los clientes', 'error')
    }
}

onMounted(async () => {
    getClients()
    if (route.name === 'users.create') {
        resetUser()
    } else if (route.params.id) {
        await fetchUser()
    }
})

</script>
